import { GetBearerToken } from "./BearerToken";
import { getImpersonateHeaders } from "./ApiClientConfig";

export const GetAxiosHeaders = async () => {
  const token = await GetBearerToken();


  const { impersonateUserId, assumeIdentity, impersonateAccount, demoData, impersonateEmail } = getImpersonateHeaders();

  if (token === null) {
    console.error("Axios Token is null");
  }

  return {
    ...(impersonateUserId && { ImpersonateUserId: impersonateUserId }),
    ...(assumeIdentity && { AssumeIdentity: assumeIdentity }),
    ...(impersonateAccount && { ImpersonateAccount: impersonateAccount }),
    ...(demoData && { DemoData: demoData }),
    ...(impersonateEmail && { ImpersonateEmail: impersonateEmail }),
    Authorization: `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    "Content-type": "application/json",
  };
};
